import React from 'react';

const IconClose12 = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
      <g fill="none" fillRule="evenodd">
        <g fill="#5A5A5A">
          <g>
            <g>
              <g>
                <g>
                  <g>
                    <path
                      d="M6.906 6.094l3.613-3.614c.225-.224.225-.587 0-.812-.224-.224-.587-.224-.812 0L6.094 5.282 2.48 1.668c-.224-.224-.587-.224-.812 0-.224.225-.224.588 0 .812l3.614 3.614-3.614 3.613c-.224.225-.224.588 0 .812.112.112.26.168.406.168.147 0 .294-.056.406-.168l3.614-3.613 3.613 3.613c.112.112.26.168.406.168.147 0 .294-.056.406-.168.225-.224.225-.587 0-.812L6.906 6.094z"
                      transform="translate(-752 -492) translate(154 84) translate(0 310) translate(440 84) translate(152 8) translate(6 6)"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default IconClose12;
